/* eslint-disable react/no-multi-comp */
import React, { PureComponent } from 'react';
import moment from 'moment';
import {
    LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer
} from 'recharts';
import translation from './lang';
import { ReactComponent as SaleIcon } from './assets/sale.svg';
import { ReactComponent as ProductIcon } from './assets/products.svg';
import { ReactComponent as SizeIcon } from './assets/size.svg';

class CustomizedLabel extends PureComponent {
    render() {
        const {
            x, y, stroke, value,
        } = this.props;

        return <text x={x} y={y} dy={-4} fill={stroke} stroke="var(--orange)" fontWeight={100} fontSize={12} textAnchor="middle">{parseInt(value).toLocaleString()}</text>;
    }
}

class CustomizedAxisTick extends PureComponent {
    render() {
        const {
            x, y, payload, period
        } = this.props;

        let text = '';
        console.log(period);

        if (period === 'current') {
            text = translation[this.props.lang || 'uz'][payload.value.toLowerCase()]
        } else if (period === 'quater') {
            text = translation[this.props.lang || 'uz'][payload.value.toLowerCase()]
        } else if (period === 'semiannual' || period === 'annual') {
            text = translation[this.props.lang || 'uz'].short[payload.value.toLowerCase()]
        } else {
            text = payload.value;
        }
        return (
            <g transform={`translate(${x},${y})`}>
                <text x={0} y={0} dy={16} fontSize={14} textAnchor="end" fill="#666" transform="rotate(-35)">{text}</text>
            </g>
        );
    }
}

class Profit extends PureComponent {
    state = {
        remainingItems: 0,
        remainingSize: 0
    }
    componentDidMount() {
        const remainingProducts = this.props.products.reduce((totalAmount, item) => {
            totalAmount.remainingItems += parseInt(item.piece);
            totalAmount.remainingSize += parseInt(parseInt(item.piece) * parseFloat(item.totalSize));
            return totalAmount;
        }, { remainingItems: 0, remainingSize: 0 });

        this.setState({ ...remainingProducts })
    }
    render() {
        const { period, data = [], lang = "en" } = this.props;

        let currentData = [];
        if (period === 'current') {

            for (let i = 1; i <= 7; i++) {
                const startDay = moment().weekday(i).hour(0).minute(0).second(0).valueOf();
                const endDay = moment().weekday(i).hour(23).minute(59).second(59).valueOf();
                const currentDayName = moment().weekday(i).format('dddd');

                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sold += parseInt(sale.piecesForSale);
                        totalAmount.size += parseInt(sale.totalSize);
                    }
                    return totalAmount;
                }, { sold: 0, size: 0 });

                currentData.push({ ...thisWeekSale, name: currentDayName });
            }
        } else if (period === 'month') {
            const numOfDaysInMonth = moment().daysInMonth();
            for (let i = 1; i <= numOfDaysInMonth; i++) {

                const startDay = moment().date(i).hour(0).minute(0).second(0).valueOf();
                const endDay = moment().date(i).hour(23).minute(59).second(59).valueOf();
                const currentDayName = moment().date(i).format('DD');

                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sold += parseInt(sale.piecesForSale);
                        totalAmount.size += parseInt(sale.totalSize);
                    }
                    return totalAmount;
                }, { sold: 0, size: 0 });

                currentData.push({ ...thisWeekSale, name: currentDayName }); console.log(currentData)
            }
        } else if (period === 'quater') {

            for (let i = 0; i < 3; i++) {

                const startDay = moment().subtract(i, 'month').startOf('month').valueOf();
                const endDay = moment().subtract(i, 'month').endOf('month').valueOf();
                const currentDayName = moment().subtract(i, 'month').format('MMMM');

                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sold += parseInt(sale.piecesForSale);
                        totalAmount.size += parseInt(sale.totalSize);
                    }
                    return totalAmount;
                }, { sold: 0, size: 0 });
                currentData.unshift({ ...thisWeekSale, name: currentDayName });
            }
        } else if (period === 'semiannual') {

            for (let i = 0; i < 6; i++) {

                const startDay = moment().subtract(i, 'month').startOf('month').valueOf();
                const endDay = moment().subtract(i, 'month').endOf('month').valueOf();
                const currentDayName = moment().subtract(i, 'month').format('MMMM');

                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sold += parseInt(sale.piecesForSale);
                        totalAmount.size += parseInt(sale.totalSize);
                    }
                    return totalAmount;
                }, { sold: 0, size: 0 });

                currentData.unshift({ ...thisWeekSale, name: currentDayName });
            }
        } else if (period === 'annual') {

            for (let i = 0; i < 12; i++) {

                const startDay = moment().subtract(i, 'month').startOf('month').valueOf();
                const endDay = moment().subtract(i, 'month').endOf('month').valueOf();
                const currentDayName = moment().subtract(i, 'month').format('MMMM');

                console.log(currentDayName, new Date(startDay).toLocaleString(), new Date(endDay).toLocaleString());


                const thisWeekSale = data.reduce((totalAmount, sale) => {

                    if (sale.updatedAt >= startDay && sale.updatedAt <= endDay) {
                        totalAmount.sold += parseInt(sale.piecesForSale);
                        totalAmount.size += parseInt(sale.totalSize);
                    }
                    return totalAmount;
                }, { sold: 0, size: 0 });

                currentData.unshift({ ...thisWeekSale, name: currentDayName });
            }
        }

        const widgetData = {
            sold: currentData.reduce((sum, value) => sum += value.sold, 0),
            size: currentData.reduce((sum, value) => sum += value.size, 0),
        }

        return (
            <div className="my-5" id="dashboard-profit">
                <h2 className="text-center my-5">Sotuv natijalari</h2>

                <div className="pt-1 pb-5 rounded">
                    <div className="row">
                        <div className="col-md-6 mb-md-0 mb-5">
                            <div className="row">
                                <div className="col-6">
                                    <div className="card bg-success text-white mb-4 sale">
                                        <div><SaleIcon fill="#fff" strokeWidth="1" /></div>
                                        <div className="card-body text-center">
                                            <h4>{parseInt(widgetData.sold).toLocaleString()} <sub className="card-pieces">{translation[lang].pieces}</sub></h4>
                                            <h6 className="mb-0">{translation[lang].sold}</h6>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-6">
                                    <div className="card bg-success text-white mb-4 sale">
                                        <div><ProductIcon fill="#fff" strokeWidth="1" /></div>
                                        <div className="card-body text-center">
                                            <h4>{parseInt(this.state.remainingItems).toLocaleString()} <sub className="card-pieces">{translation[lang].pieces}</sub></h4>
                                            <h6 className="mb-0">{translation[lang].remainingItems}</h6>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <ResponsiveContainer width="100%" height={400} className="mt-5 graph">
                                <LineChart
                                    // width={700}
                                    // height={400}
                                    data={currentData}
                                    style={{ overflow: 'visible' }}
                                    margin={{ top: 30, right: 30, left: -10, bottom: 25 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis minTickGap={0} dataKey="name" height={60} tick={<CustomizedAxisTick lang={lang} period={period} />} />
                                    <YAxis allowDecimals tickFormatter={(value) => value.toLocaleString()} />
                                    <Tooltip
                                        formatter={(value, name, props) => ([value.toLocaleString(), translation[this.props.lang || 'uz'][name.toLowerCase()]])}
                                        labelFormatter={value => {
                                            if (period === 'current') {
                                                return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                            } else if (period === 'quater') {
                                                return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                            } else if (period === 'semiannual') {
                                                return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                            } else if (period === 'annual') {
                                                return translation[this.props.lang || 'uz'].short[value.toLowerCase()]
                                            } else {
                                                return value
                                            }
                                        }}
                                    />
                                    <Legend formatter={(value) => translation[this.props.lang || 'uz'][value.toLowerCase()]} />
                                    <Line type="monotone" dataKey="sold" strokeWidth={2} stroke="#8884d8" label={<CustomizedLabel lang={lang} period={period} />} />
                                </LineChart>
                            </ResponsiveContainer>

                        </div>
                        <div className="col-md-6 mt-md-0 mt-5">
                            <div className="row">
                                <div className="col-6">
                                    <div className="card bg-success text-white mb-4 sale">
                                        <div><SizeIcon fill="#fff" strokeWidth="1" /></div>
                                        <div className="card-body text-center">
                                            <h4>{parseInt(widgetData.size).toLocaleString()} m<sup className="card-currency">2</sup> </h4>
                                            <h6 className="mb-0">{translation[lang].size}</h6>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-6">
                                    <div className="card bg-success text-white mb-4 sale">
                                        <div><SizeIcon fill="#fff" strokeWidth="1" /></div>
                                        <div className="card-body text-center">
                                            <h4>{parseInt(this.state.remainingSize).toLocaleString()} m<sup className="card-currency">2</sup> </h4>
                                            <h6 className="mb-0">{translation[lang].remainingSize}</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <ResponsiveContainer width="100%" height={400} className="mt-5 graph">
                                <LineChart
                                    // width={700}
                                    // height={400}
                                    data={currentData}
                                    style={{ overflow: 'visible' }}
                                    margin={{ top: 30, right: 30, left: -10, bottom: 25 }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis minTickGap={0} dataKey="name" height={60} tick={<CustomizedAxisTick lang={lang} period={period} />} />
                                    <YAxis allowDecimals tickFormatter={(value) => value.toLocaleString()} />
                                    <Tooltip
                                        formatter={(value, name, props) => ([value.toLocaleString(), translation[this.props.lang || 'uz'][name.toLowerCase()]])}
                                        labelFormatter={value => {
                                            if (period === 'current') {
                                                return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                            } else if (period === 'quater') {
                                                return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                            } else if (period === 'semiannual') {
                                                return translation[this.props.lang || 'uz'][value.toLowerCase()]
                                            } else if (period === 'annual') {
                                                return translation[this.props.lang || 'uz'].short[value.toLowerCase()]
                                            } else {
                                                return value
                                            }
                                        }}
                                    />
                                    <Legend formatter={(value) => translation[this.props.lang || 'uz'][value.toLowerCase()]} />
                                    <Line type="monotone" dataKey="size" strokeWidth={2} stroke="#82ca9d" label={<CustomizedLabel lang={lang} period={period} />} />
                                </LineChart>
                            </ResponsiveContainer>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
export default Profit;